(() => {
  const setup = (root = document) => {
    root.querySelectorAll('[data-bpr-tabs]').forEach(container => {
      if (container.dataset.bprInitialized) return;
      container.dataset.bprInitialized = 'true';
      const tabs = Array.from(container.querySelectorAll('[role="tab"]'));
      const activate = tab => {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (next) { event.preventDefault(); activate(next); next.focus(); }
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('click', event => {
    document.querySelectorAll('.bpr-departments[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.bpr-departments[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
})();
(() => {
  let pending;
  const updateCount = () => {
    clearTimeout(pending);
    pending = setTimeout(async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        const cart = await response.json();
        document.querySelectorAll('[data-bpr-cart-count]').forEach(el => { el.textContent = String(cart.item_count); });
      } catch {}
    }, 150);
  };
  const watch = () => {
    new MutationObserver(records => {
      if (records.some(record => record.target instanceof Element && (record.target.closest('.previewCart-wrapper') || (document.body.classList.contains('template-cart') && record.target.closest('#MainContent'))))) updateCount();
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  window.addEventListener('pageshow', updateCount);
  document.addEventListener('cart:updated', updateCount);
  document.addEventListener('submit', event => {
    if (event.target.matches('form[data-type="add-to-cart-form"]')) {
      updateCount();
      setTimeout(updateCount, 900);
    }
  }, true);
})();
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (root = document) => {
    root.querySelectorAll('[data-bpr-tabs]').forEach(section => {
      if (section.dataset.bprRailReady) return;
      section.dataset.bprRailReady = 'true';
      const previous = section.querySelector('[data-bpr-rail-prev]');
      const next = section.querySelector('[data-bpr-rail-next]');
      const activeRail = () => section.querySelector('[role="tabpanel"]:not([hidden]) .bpr-product-grid');
      const update = () => {
        const rail = activeRail();
        if (!rail) return;
        if (previous) previous.disabled = rail.scrollLeft < 3;
        if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
      };
      const move = direction => {
        const rail = activeRail();
        if (rail) rail.scrollBy({left: direction * rail.clientWidth * 0.85, behavior: reduced.matches ? 'instant' : 'smooth'});
      };
      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      section.querySelectorAll('.bpr-product-grid').forEach(rail => rail.addEventListener('scroll', update, {passive:true}));
      section.querySelectorAll('[role="tab"]').forEach(tab => {
        tab.addEventListener('click', () => requestAnimationFrame(update));
        tab.addEventListener('keydown', event => { if (['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) requestAnimationFrame(update); });
      });
      window.addEventListener('resize', update, {passive:true});
      update();
    });
    root.querySelectorAll('[data-bpr-collection-toggle]').forEach(button => {
      if (button.dataset.bprInitialized) return;
      button.dataset.bprInitialized = 'true';
      button.addEventListener('click', () => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        panel.hidden = !expanded;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

(() => {
  const init = (root = document) => {
    root.querySelectorAll('.bpr-featured-form').forEach(form => {
      if (form.dataset.bprAddReady) return;
      form.dataset.bprAddReady = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        const status = form.querySelector('[role="status"]');
        if (!button || button.disabled) return;
        clearTimeout(form.bprResetTimer);
        button.disabled = true;
        button.textContent = button.dataset.adding;
        button.removeAttribute('data-added');
        if (status) { status.textContent = ''; status.removeAttribute('data-error'); }
        try {
          const rootUrl = window.Shopify?.routes?.root || '/';
          const response = await fetch(rootUrl + 'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body:new FormData(form),credentials:'same-origin'});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || button.dataset.error);
          button.textContent = button.dataset.addedLabel + ' ✓';
          button.setAttribute('data-added', 'true');
          if (status) status.textContent = button.dataset.addedLabel;
          try {
            const cartResponse = await fetch(rootUrl + 'cart.js', {credentials:'same-origin',cache:'no-store'});
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              document.querySelectorAll('[data-bpr-cart-count]').forEach(node => { node.textContent = String(cart.item_count); });
            }
          } catch {}
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (error) {
          button.textContent = button.dataset.label;
          if (status) { status.textContent = error.message || button.dataset.error; status.dataset.error = 'true'; }
        } finally {
          button.disabled = false;
          form.bprResetTimer = setTimeout(() => { button.textContent = button.dataset.label; button.removeAttribute('data-added'); }, 2500);
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
